import { mapActions,mapState,mapMutations } from "vuex";
import { track } from "@/services/track-custom";
import { trackTopsort } from "@/services/track-topsort";
import { profile } from '@/services/profile';
import * as Sentry from "@sentry/vue";

export const misMixins = {
  computed: {
    ...mapState('customer', ["instance", "polygon","supplier"]),
    ...mapState('ontable', [ "tableId" ]),
    ...mapState('profile', [ "profile", "session" ]),
    ...mapState('order', [ "service" ])
  },
  methods: {
    ...mapActions('customer', ["GetSupplier"]),
    ...mapMutations('shared', ["SetProductId"]),
    clickBanner(item, data_track) {
      let event = '';
      if (data_track.content_popup) {
        event = 'click popup';
        if (data_track.event && data_track.event.length > 1) event = data_track.event;
      };
      if (data_track.content_home) event = 'click banner';
      if (event) this.handleEventTracking(event, item.url, data_track);
      this.handlePopupTopSort(data_track);
      if (item.url && item.url.tipe) this.handleUrlType(item.url, item.layout_type,item.target);
    },
    handleEventTracking(event, url, data_track) {
      try {
        if (url) {
          if (url.tipe === "producto") {
            event += '.producto';
            data_track.product_supplier_id = url.param;
          };
          if (url.tipe === "categoria") {
            event += '.subcategoria';
            data_track.subcategory_id = url.param;
          };
        };
        track.trackEventCluvi(data_track, event);
      } catch (error) {
        Sentry.captureException(error);
      };
    },
    handlePopupTopSort(data_track) {
      if (data_track.content_popup?.topsortWinner?.resolvedBidId?.length > 1) trackTopsort.trackBannerClick(data_track.content_popup);
    },
    handleUrlType(url, layout_type,target) {
      switch (url.tipe) {
        case "producto":
          this.SetProductId(url.param);
          break;
        case "categoria":
          this.tipeCategorie(url);
          break;
        case "externo":
          this.tipeExternal(url,target);
          break;
        default:
          break;
      };
      if (layout_type === 'banner') this.layoutTypeBanner(url,target);
    },
    tipeCategorie (item) {
      const objRedirectionCategorie = {
        name: "SubCategories",
        params: { supplier_id: this.supplier.slug },
        query: {}
      };
      if (item.main_category_id) objRedirectionCategorie.query.maincategory_id = item.main_category_id;
      if (item.param) objRedirectionCategorie.query.category_id =  item.param;
      this.$router.push(objRedirectionCategorie);
    },
    layoutTypeBanner (item,target) {
      let url = item.param;
      if (typeof(url) === 'string') {
        const includeCluvi =  url?.includes('.cluvi.');
        const includeTypeform = url?.includes('form.typeform.com');
        if (includeCluvi) url = `${url}${this.tableId? `?mesa=${this.tableId}`:''}`.trim();
        if (includeTypeform) url = `${url}#supplier_id=${this.supplier.id}&session_id=${this.session.id}&service=${this.service}`.trim();
        if (includeCluvi || includeTypeform) this.redirectionUrl(item,url,target);
      };
    },
    tipeExternal (item,target) {
      let url = null;
      let isUrlRate = item.param.includes('qualification');
      let branchIdRoute = item.param.includes(this.$route.params.supplier_id);
      if (isUrlRate) {
        var urlString = item.param;
        var regex = /([^/]+)\/menu-digital/;
        var matches = urlString.match(regex);
        if (matches && matches.length >= 2) {
          var extractedPart = matches[1];
          url = branchIdRoute ? item.param : item.param.replace(extractedPart,this.$route.params.supplier_id);
        } else {
          ("Dont found url");
        };
      } else {
        url = item.param;
      };
      this.redirectionUrl(item,url,target);
    },
    redirectionUrl (item,url,target) {
      if (item && target) window.open(url,target);
      else window.open(url,target);
    },
    back () {
      if (this.$route.name === "Product") {
        if (this.service === "on_table") {
          this.$router.push({
            name: "OnTableHome",
            params: { supplier_id: this.supplier.slug }
          });
        } else {
          this.$router.push({
            name: "Home",
            params: { supplier_id: this.supplier.slug }
          });
        };
      } else {
        this.$router.go(-1);
      };
    },
    async validateProfile () {
      try {
        if (!this.profile.id && !this.profile.token) await profile.init();
      } catch (error) {
        console.error(error);
      };
    },
    async reloadGetSupplier () {
      try {
        if (this.$route.params.supplier_id !== this.supplier.slug) await this.GetSupplier(this.$route.params.supplier_id);
        else this.GetSupplier(this.$route.params.supplier_id);
      } catch (error) {
        console.error(error);
      };
    }
  }
}